import { pxToRem } from 'utils/convert';

export const borderWidth1 = `solid ${pxToRem(1)}`;
export const borderWidth2 = `solid ${pxToRem(2)}`;
export const borderWidth4 = `solid ${pxToRem(4)}`;
